import React from 'react';
import { Menu, Tab, Header, Segment } from 'semantic-ui-react';
import { MenuConsumer } from '../../../FoodMenu.context';
import { CategoryContainer } from '../category';
import CategoryNavigation from './CategoryNavigation';

import './Navigation.css';

const NavigationBasicTabs = ({ center }) => {
  return (
    <MenuConsumer>
      {({ schedules, categories, disableSchedules }) => {
        const isSingleSchedule = schedules.length === 1;

        if (isSingleSchedule) {
          return (
            <React.Fragment>
              <CategoryNavigation categories={categories} />
              <Segment attached="bottom" className="fc-menu-category-segment-container">
                <CategoryContainer scheduleId={schedules[0]._id} />
              </Segment>
            </React.Fragment>
          )
        }

        const panes = schedules.map(schedule => {
          const { name, _id } = schedule;

          return {
            menuItem: (
              <Menu.Item key={name}>
                {!disableSchedules && <Header as="h3">{name}</Header>}
              </Menu.Item>
            ),
            render: () => (
              <Tab.Pane key={name}>
                <CategoryContainer scheduleId={_id} />
              </Tab.Pane>
            ),
          };
        });

        return <Tab panes={panes} className={getClassNames({ center, disableSchedules })} />;
      }}
    </MenuConsumer>
  );
};

function getClassNames({ center, disableSchedules }) {
  let classNames = ['fcfm-tabs-container'];

  if (center) classNames = [...classNames, 'center'];
  if (disableSchedules) classNames = [...classNames, 'disable-menu-schedules'];

  return classNames.join(' ');
}

export default NavigationBasicTabs;
